
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin/forgot/password",
      function () {
        return require("private-next-pages/signin/forgot/password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signin/forgot/password"])
      });
    }
  